// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PMinusSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PMinusSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PMinusSquareOutlined = function PMinusSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PMinusSquareOutlinedSvg
  }));
};

PMinusSquareOutlined.displayName = 'PMinusSquareOutlined';
export default React.forwardRef(PMinusSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PMinusSquareOutlined.js
// module id = 3516
// module chunks = 0